// ── Application routes ───────────────────────────────────────────────────────
// Single source of truth for all client-side route paths.
// App.js defines the <Route> elements; this file provides the path strings
// that navigate() calls and <Link> components should reference.

export const ROUTES = Object.freeze({
  HOME: '/',
  CREATE: '/create',
  COLLECTION: '/collection',
  PROFILE: '/profile',
  MY_ROOMS: '/my-rooms',
  ROOMS: '/rooms',
  ADMIN: '/admin',
  TERMS: '/terms-of-service',
  PRIVACY: '/privacy',
  FAQ: '/faq',
  ANNOUNCEMENTS: '/announcements',

  // ── Editor step routes ──────────────────────────────────────────────────
  EDITOR: {
    /** Step 3 / general editor — also the wildcard catch-all */
    ROOT: (id) => `/editor/${id}`,
    /** Step 1 — room size selection */
    ROOM_SELECTION: (id) => `/editor/room-selection/${id}`,
    /** Step 2 — wall type */
    WALLS: (id) => `/editor/room-walls/${id}`,
    /** Step 2b — decorations */
    DECORATIONS: (id) => `/editor/room-decorations/${id}`,
    /** Step 4 — settings / publish */
    SETTINGS: (id) => `/editor/room-settings/${id}`,
  },

  // ── Player routes ───────────────────────────────────────────────────────
  /** Unpublished room by ID */
  PLAYER: (id) => `/player/${id}`,
  /** Published snapshot */
  PUBLISHED: (id) => `/play/${id}`,
  /** Room accessed via globally-unique slug */
  ROOM_BY_SLUG: (slug) => `/${slug}`,

  // ── Auth routes (parameterised by roomId for post-auth redirect) ────────
  SIGNUP: (roomId) => `/signup/${roomId}`,
  SIGN_IN: (roomId) => `/sign-in/${roomId}`,

  // ── Creator profile ─────────────────────────────────────────────────────
  CREATOR_PROFILE: (username) => `/u/${username}`,

  // ── Template ────────────────────────────────────────────────────────────
  TEMPLATE: (roomId) => `/template/${roomId}`,
});
